<template>
    <div class = "shipping-address-view" v-loading = 'loading'>
    </div>
</template>

<script>
import { useShippingAddressStore } from '@/stores/ShippingAddressStore.ts';
import { useCommonStore } from "@/stores/CommonStore.ts";
import { mapActions } from 'pinia';
import { ElNotification } from 'element-plus';
export default{
    async mounted(){
        this.loading = true;
        //comment for staging test: more convenient to track the redirect link's data;
        console.log('shippingAddressView link', this.$route.query, this.$route.query && Object.keys(this.$route.query).length > 0);

        // Check whether has query params. 
        // If so, set top bar, store query params, fetch needed data from graphQL, and redirect to /informationLanding
        // NOTES: If no query params, means INVALID access request, such as directly typing URL
        try{
            if(this.$route.query && Object.keys(this.$route.query).length > 0){
                // 1. save query info in localStorage: for user refresh on /informationLanding
                localStorage.setItem('pns_single_page_query', JSON.stringify(this.$route.query));

                // 2. set data in CommonStore: for the top header information and 'pnsToken' in localStorage
                this.setAccessionId(this.$route.query.accession_id);
                this.setSampleId(this.$route.query.sample_id);
                this.setJwtToken(this.$route.query.token);

                // 3. set data in shippingAddressStore: for related apis after redirect to /informationLanding
                // NOTES: need to use await, since storeAllQueryInfomation might throw Error
                await this.storeAllQueryInfomation(this.$route.query);

                // 4. redirect to /informationLanding
                this.$router.push('/informationLanding');
            }else{
            //If no query params, DON'T allow any operations: error notification, clear query in localStorage, and redirect to GeneralFailed page
            
                //remove previous query info in localStorage: in case there is a previous record there
                localStorage.removeItem('pns_single_page_query');
                ElNotification({
                    title: 'Error',
                    type: 'error',
                    customClass: "errorNotification",
                    message: 'No query information found.',
                    duration: 0,
                });
                this.$router.push('/failed');
            }
        }catch(err){
            console.log('ShippingAddressMedia mounted error: ', err);
            ElNotification({
                title: 'Failed',
                type: 'error',
                customClass: "errorNotification",
                message: err?.message ?? 'ShippingAddressMedia mounted error.',
                duration: 0,
            });
            this.$router.push('/failed');
        }finally{
        // guarantee to end loading
            this.loading = false;
        }
       
    },
    data(){
        return{
            loading:false,
        }
    },
    methods:{
        ...mapActions(()=>useShippingAddressStore(),[
            'storeAllQueryInfomation',
        ]),
        ...mapActions(()=>useCommonStore(), [
            'setAccessionId',
            'setSampleId',
            'setJwtToken'
        ])
    }
}
</script>

<style scoped>
.shipping-address-view{
    min-height: calc(100vh - 77px);
    padding-bottom: 114px;
}
@media only screen and (max-width: 767px){
    .shipping-address-view{
        padding-bottom: 104px;
    }
}
</style>